// /* eslint-disable functional/prefer-readonly-type */
// /* eslint-disable functional/no-this-expression */
// /* eslint-disable functional/immutable-data */
// /* eslint-disable functional/no-class */
import { action, computed, configure, observable } from 'mobx';

import { TableDataState } from './table-types';
//import { TableDataState } from 'motion-components';

configure({ enforceActions: 'always' }); // strict mode

//------------------------------------------------------
// *    --- Functions ---
//

// *    --- Store Class ---
//
export class TableStore {
  @observable accessor tableName = '';
  @observable accessor state = TableDataState.browse;
  @observable accessor activeRowIdx: number | undefined = undefined;

  @observable accessor table: any = null;
  @action setTable(tableValue: any): void {
    this.table = tableValue;
  }
  // *
  // * --------------- Getters -------------------------------

  // *
  // * --------------- Setters -------------------------------
  @action setTableName(newTableName: string): void {
    this.tableName = newTableName;
  }

  @action setState(newState: TableDataState): void {
    this.state = newState;
  }

  @action setActiveRowIdx(rowIdx: any): void {
    if (rowIdx !== undefined) this.activeRowIdx = parseInt(rowIdx);
    else this.activeRowIdx = undefined;
  }

  constructor() {
    this.init();
  }

  @action private init() {
    console.log(`[Table-Store] init`);
    this.tableName = '';
    this.state = TableDataState.browse;
    this.table = null;
  }
}
